export default "__VITE_ASSET__Ds_DvnN$__"